import React, { useState, useEffect } from "react";
import { getCustomerBillSummaryItemWise } from "../../../api/endpoints/allReports.js";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar.js";
import { getAllPartySearch } from "../../../api/endpoints/search.js";
import { Button, Dropdown, Select, Menu } from "antd";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
const { Option } = Select;

const CustomerBillSummaryItemWise = () => {
  const { access_token } = useSelector(authSelector);
  const [enteredOn, setEnteredOn] = useState("");
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    enteredOn: "",
    startingDate: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  console.log(state, "Stateeeeee");
  const [itemsQueue, setItemsQueue] = useState([]);

  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);

    setState({
      ...state,
      parties: _parties,
    });
  };
  useEffect(() => {
    getAllData();
    getName();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };
  const [loading, setLoading] = useState(false);

  const editHandler = async (e) => {
    if (!state.enteredOn) return message.error("Please type Ending date !");
    if (!state.startingDate)
      return message.error("Please type Starting date !");
    if (!state.partyId) return message.error("Please type Party Id !");
    let data = {
      startingDate: state.startingDate,
      enteredOn: state.enteredOn,
      partyId: state.partyId,
    };
    try {
      setLoading(true); // disable button
      const results = await getCustomerBillSummaryItemWise(data, access_token);
      console.log(results.data.length, "ressaaaaa");
      if (results.data.length === 0) {
        message.error("No Record Found in these date");
      }
      if (results.success) {
        const payload = results.data.reduce((acc, curr) => {
          return [
            ...acc,
            {
              enteredOn: curr.enteredOn,
              partyId: Number(curr.partyId),
              vehicalId: Number(curr.vehicalId),
              regNumber: curr.regNumber,
              partyName: curr.partyName,
              couponNo: Number(curr.couponNo),
              itemCode: curr.itemCode,
              itemName: curr.itemName,
              saleRate: Number(curr.saleRate),
              quantity: Number(curr.quantity),
              amount: Number(curr.amount),
              debit: Number(curr.debit),
              siteId: curr.siteId,
              printOrder: curr.printOrder,
            },
          ];
        }, []);
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

 const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  // ====== Header (printed once) ======
  const now = new Date();
  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
  doc.setFontSize(8);
  doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
  doc.setFontSize(16);
  doc.text(siteName, 103, 11, { align: "center" });
  doc.setFontSize(12);
  doc.text(siteAddress, 103, 16, { align: "center" });
  doc.setFontSize(10);
  doc.text(
    `${state.partyName} From: ${formatDate(state.startingDate)} To ${formatDate(state.enteredOn)}`,
    103,
    20,
    { align: "center" }
  );

  // ====== Group by itemCode ======
  const groupedByItem = data.reduce((acc, row) => {
    if (!acc[row.itemCode]) acc[row.itemCode] = [];
    acc[row.itemCode].push(row);
    return acc;
  }, {});

  let grandTotalQty = 0;
  let grandTotalAmt = 0;
  const tableRows = [];
  let sno = 1;

  Object.keys(groupedByItem).forEach((itemCode) => {
    const rows = groupedByItem[itemCode];
    rows.sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn));

    // Add rows for each entry
    rows.forEach((r) => {
      tableRows.push([
        sno++,
        r.regNumber || "",
        r.itemName || "",
        r.quantity.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        r.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      ]);
    });

    // Item-wise totals
    const totalQty = rows.reduce((sum, r) => sum + (Number(r.quantity) || 0), 0);
    const totalAmt = rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

    tableRows.push([
      "",
      "",
      `Total (${rows[0]?.itemName || itemCode})`,
      totalQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      totalAmt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    ]);

    grandTotalQty += totalQty;
    grandTotalAmt += totalAmt;
  });

  // Grand Total row
  tableRows.push([
    "",
    "",
    "Grand Total",
    grandTotalQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    grandTotalAmt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  ]);

  // ====== Render one table ======
  autoTable(doc, {
    head: [["SNO", "REG NUMBER", "ITEM NAME", "QUANTITY", "AMOUNT"]],
    body: tableRows,
    startY: 25,
    theme: "grid",
    margin: { left: 10, right: 10 },
    styles: {
      fontSize: 9,
      cellPadding: 1,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
      valign: "middle",
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 20 }, // SNO
      1: { halign: "center", cellWidth: 50 }, // Reg Number
      2: { halign: "left", cellWidth: 50 },   // Item
      3: { halign: "right", cellWidth: 35 },  // Quantity
      4: { halign: "right", cellWidth: 35 },  // Amount
    },
    didParseCell: (data) => {
      const isTotalRow =
        data.row.raw[2]?.toString().startsWith("Total") ||
        data.row.raw[2] === "Grand Total";
      if (isTotalRow) {
        data.cell.styles.fontStyle = "bold";
      }
    },
  });

  // ====== Open PDF in new tab ======
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};


  console.log(itemsQueue, "payy");
  return (
    <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className=" text-white">
                      Customer Bill Summary Item Wise
                    </h1>
                  </div>
                  <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                    <div>
                      <label className="text-white" for="fname">
                        Starting Date:
                      </label>
                      <input
                        type="date"
                        name="startingDate"
                        value={state.startingDate}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                      <label className="text-white ml-2" for="fname">
                        Ending Date:
                      </label>
                      <input
                        type="date"
                        name="enteredOn"
                        value={state.enteredOn}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                    </div>
                    <div>
                      <label className="text-white ml-2 mr-2" for="fname">
                        Account:
                      </label>
                      <Select
                        showSearch
                        style={{
                          cursor: "pointer !important",
                          background: "red !important",
                        }}
                        name="partyId"
                        placeholder="A/C No."
                        className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
                        optionFilterProp="children"
                        value={state.partyId || "A/C No."}
                        onChange={(e) => {
                          console.log("e", e);

                          const _party = state.parties.find(
                            (el) => el.partyId === e
                          );
                          if (_party) {
                            setState({
                              ...state,
                              partyId: e,
                              partyName: _party.PartyName,
                            });
                          } else {
                            setState({
                              ...state,
                              partyId: e,
                              partyName: "",
                            });
                          }
                        }}
                      >
                        <Option value={0}>None</Option>
                        {state.parties.map((el) => (
                          <Option
                            className="w-auto"
                            value={el.partyId}
                          >{`${el.partyId} - ${el.PartyName}`}</Option>
                        ))}
                      </Select>
                    </div>
                    <div>
                      <button
                        className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                          loading
                            ? "opacity-50 cursor-not-allowed"
                            : "hover:bg-blue-700"
                        }`}
                        onClick={editHandler}
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "View"}
                      </button>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                        clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </>
  );
};

export default CustomerBillSummaryItemWise;
